import React, { createContext, useState, useContext, useCallback } from 'react';

const WalletContext = createContext(null);

export function WalletProvider({ children }) {
  const [rewards, setRewards] = useState([
    { id: '1', type: 'giftcard', store: 'Tim Hortons', amount: '$10', color: '#C8102E', date: 'Jan 20' },
    { id: '2', type: 'screentime', app: 'TikTok', minutes: 30, date: 'Jan 18' },
    { id: '3', type: 'giftcard', store: 'Starbucks', amount: '$15', color: '#00704A', date: 'Jan 15' },
  ]);

  const addReward = useCallback((reward) => {
    setRewards(prev => [{
      ...reward,
      id: String(Date.now()),
      date: 'Today',
    }, ...prev]);
  }, []);

  const giftCards = rewards.filter(r => r.type === 'giftcard');
  const screenTimeRewards = rewards.filter(r => r.type === 'screentime');

  return (
    <WalletContext.Provider value={{ rewards, giftCards, screenTimeRewards, addReward }}>
      {children}
    </WalletContext.Provider>
  );
}

export function useWallet() {
  const context = useContext(WalletContext);
  if (!context) throw new Error('useWallet must be used within WalletProvider');
  return context;
}
